export type CurrencyRegion = {
  id: string;
  slug: string;
  name: string;
  currency: string;
  is_default: boolean;
  notes: string;
  countries: { code: string }[];
  country_count: number;
  organization_count: number;
  has_prices: boolean;
};

export type CountryRow = {
  code: string;
  name: string;
  region: { id: string; name: string; slug: string; currency: string } | null;
};

export function defaultRegion(regions: CurrencyRegion[]) {
  return regions.find((region) => region.is_default) ?? regions[0];
}

export function regionBySlug(regions: CurrencyRegion[], slug: string) {
  return regions.find((region) => region.slug === slug);
}

/** The default first, then by name: the default is the one you read against. */
export function inReadingOrder(regions: CurrencyRegion[]) {
  return [...regions].sort((a, b) => {
    if (a.is_default !== b.is_default) return a.is_default ? -1 : 1;
    return a.name.localeCompare(b.name);
  });
}
